import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CustomerDataModel } from 'src/app/customer/customer-data-model';

@Component({
    selector: 'app-account-document-dialog',
    templateUrl: './account-document-dialog.component.html',
    styleUrls: ['./account-document-dialog.component.scss']
})
export class AccountDocumentDialogComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<AccountDocumentDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: MatDialog,) { }
    customerDataModel = new CustomerDataModel();
    customerDetails: any = this.customerDataModel.customerDetailsModel;
    allData: any;

    ngOnInit() {
        this.allData = this.data;
    }

    onClose(): void {
        this.dialogRef.close(false);
    }

}
